<div [formGroup]="formGroup()">
  <p-select
    [options]="this.roomList$ | async"
    [styleClass]="cssClass()"
    placeholder="{{ 'SCHEDULE.CREATEAPPOINTMENT.CHOOSEROOM' | translate }}"
    [formControl]="controlName()"
    optionLabel="name_primary_language"
    filterBy="name_primary_language"
    (onChange)="onRoomChange($event)"
  >
    @if (controlName().value) {
      <ng-template pTemplate="selectedItem">
        @if (controlName().value) {
          <div class="text-sm">
            {{ controlName().value.name_primary_language }}
          </div>
        }
      </ng-template>
    }
    <ng-template let-room pTemplate="item">
      <div class="text-sm">{{ room.name_primary_language }}</div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div
        class="text-sm border-top-1 border-300 p-3 cursor-pointer text-primary hover:surface-200"
        (click)="clickAddNewRoom()"
      >
        <i class="fa fa-plus mr-2"></i>
        {{ 'ROOM.ADD_ROOM' | translate }}
      </div>
    </ng-template>
  </p-select>
</div>

<!-- Add Room Modal  -->
<p-dialog
  [visible]="showAddNewRoom()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '540px' }"
  styleClass="no-header-modal"
  (onHide)="closePopup()"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="CreateRoomForm" (ngSubmit)="CreateRoom(CreateRoomForm)">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">{{ 'ROOM.ADD_ROOM' | translate }}</h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closePopup()"
        ></div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-4 text-sm">
        <div class="mb-4">
          <label
            for="name_primary_language"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'ROOM.PRI_NAME' | translate }}</label
          >
          <input
            type="text"
            class="w-full text-sm"
            formControlName="name_primary_language"
            pInputText
            placeholder=""
          />
          @if (
            primaryNameFormControl.touched && primaryNameFormControl.invalid
          ) {
            <app-error-msg
              [errors]="primaryNameFormControl.errors"
              [fieldLabel]="'ROOM.PRI_NAME' | translate"
            />
          }
        </div>

        <div class="">
          <label
            for="name_secondary_language"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'ROOM.SEC_NAME' | translate }}</label
          >
          <input
            type="text"
            class="w-full text-sm"
            formControlName="name_secondary_language"
            pInputText
            placeholder=""
          />
        </div>
      </div>
      <!-- Content -->

      <!-- Footer -->
      <div
        class="p-3 flex justify-content-between align-items-center border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-text text-sm"
          (click)="closePopup()"
        ></button>
        <button
          pButton
          pRipple
          type="submit"
          [label]="'ROOM.ADD_ROOM' | translate"
          class="text-sm"
          [loading]="disableSaveBtn"
        ></button>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Add Room Modal -->
